module.exports = __webpack_public_path__ + "static/media/IMG_20190808_224103.cea41b41.webp";